import type { Update } from 'modules/contracts/components/ContractHistory/ContractVersionUpdate'
import formatUpdate from 'modules/contracts/lib/formatUpdate'
import type { LegalEntityContractData } from 'modules/contracts/lib/legalEntityContractDataContext'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'

export const formatInitialCondition = (
  key: string,
  legalEntityContractData: LegalEntityContractData,
  currentVersion: ContractVersion,
  previousVersion?: ContractVersion
): Update => {
  const update = formatUpdate(key, legalEntityContractData, currentVersion, previousVersion)

  return {
    key: update.key,
    currentValue: update.currentValue,
  }
}
